import toast from 'react-hot-toast';
import useApi from '../useApi';
import { IAddAssociateClinicNewReq, IAddAssociateClinicRes } from './index.type';

const useAddAssociateClinic = ({ clinicAssociateId ,isUpdate }: { clinicAssociateId?: string ,isUpdate:string}) => {
  const url = !isUpdate ? 
    `/rtm/associated-clinic?clinicId=${clinicAssociateId }` : 
     `/rtm/associated-clinic?associatedClinicId=${isUpdate}`;
    
  const method = !isUpdate ? 'POST' : 'PUT';
  const { loading: addAssociateClinicLoading, makeApiCall } = useApi({ url, method });

  const addAssociateClinic = async (formData: IAddAssociateClinicNewReq) => {
    const { response, error } = await makeApiCall<IAddAssociateClinicNewReq, IAddAssociateClinicRes>(formData);
    
    if (response?.status === 'success') {
      toast.success(isUpdate ? 'Associate Clinic updated successfully' : 'Associate Clinic added successfully');
      return response;
    }
    
    if (error || !response?.status) {
      toast.error(error?.msg || 'Failed to save associate clinic. Please check the clinic details and try again.');
      return { status: 'fail' };
    }
  };
  
  return {
    addAssociateClinicLoading,
    addAssociateClinic,
  };
};

export default useAddAssociateClinic;